export default [
  {
    path: '/dataList/staffJournal',
    component: resolve => require(['../page.vue'], resolve),
    meta: {
        title: '店员日志',
        authLogin: true
    }
  }
  ];